// Generated types for VersioningRow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from './scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from './scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningRowReadAPI extends ScopedNodeReadAPI {
}

export interface VersioningRowWriteAPI extends ScopedNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningRowReadAPISchemaObject = ScopedNodeReadAPISchemaObject.extend({}).passthrough();
export const VersioningRowReadAPISchema: z.ZodType<VersioningRowReadAPI> = VersioningRowReadAPISchemaObject;

export const VersioningRowWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({}).passthrough();
export const VersioningRowWriteAPISchema: z.ZodType<VersioningRowWriteAPI> = VersioningRowWriteAPISchemaObject;
